import { MediasPublicModels } from '../medias';
import { ProductPublicModels } from '../product/public.api';

import { generateVideoPosterImageUseCase, getVideoForProductViewUseCase } from './application/use-cases/product-video.use-case';

export const ProductVideoPublicFunctions = {
    getVideoForProductView: ({
        color,
        productImagesLocation,
        locationDefault,
        defaultImageType,
        options,
    }: {
        color: ProductPublicModels.PublicProductColor;
        productImagesLocation: MediasPublicModels.PublicMediaLocation;
        locationDefault: MediasPublicModels.PublicMediaLocation;
        defaultImageType: string | null;
        options: {
            discardDoubleVideo?: boolean;
        };
    }) => getVideoForProductViewUseCase({
        color,
        productImagesLocation,
        locationDefault,
        defaultImageType,
        options,
    }),
    generateVideoPosterImage: ({
        video,
        image,
        discardVideos,
    }: { video: MediasPublicModels.PublicMediaResolved | null;
        image: MediasPublicModels.PublicMediaResolved | undefined;
        discardVideos: boolean;
    }) => generateVideoPosterImageUseCase({
        video,
        image,
        discardVideos,
    }),
};
